<ngx-smart-modal #planEditorModal identifier="planEditorModal" customClass="small-modal" style="background: #c2c2c220;">
    <div *ngIf="planItem != null && planScaffoldList != null">
        <h4 style="text-align: center">Novo Item Plano</h4>
        <p style="text-align: center">Adicione um item ao plano da {{planItem.storeSeoName}}.</p>
        <div class="row" style="margin: 0">
            <div class="col-lg-12 col-md-12">
                <div class="card">
                    <div class="card-content">
                        <a class="btn btn-success btn-fill" style="float: right;" *ngIf="planItem.referenceType == 2"
                            (click)="editBankFeePlanItem(planItem)">Editar Taxas</a>
                        <div class="form-group">
                            <label class="control-label">Id: <span
                                    style="font-weight: normal;">{{ planItem.id }}</span></label>
                        </div>
                        <div class="form-group">
                            <label class="control-label">SeoUrl: <span
                                    style="font-weight: normal;">{{ planItem.storeUrl }}</span>
                            </label>
                        </div>
                        <div class="form-group" *ngIf="planScaffoldList != null">
                            <label class="control-label">Plano:</label>
                            <select (change)="ChangePlanScaffold(planScaffold.value)" #planScaffold class="form-control"
                                name="planId" [(ngModel)]="planItem.planId">
                                <option *ngFor="let plan of planScaffoldList" [ngValue]="plan.id">{{plan.seoName}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group" *ngIf="featureList != null && planItem.planSeoName == 'feature'">
                            <div class="row">
                                <div class="col-lg-12 col-md-12">
                                    <hr>
                                    <label class="control-label">Feature:</label>
                                    <br>
                                    <small>Para add uma nova feature, não basta só selecionar, precisa clicar em "+
                                        feature"</small>
                                </div>
                                <div class="col-lg-10 col-md-10">
                                    <select class="form-control" name="featureId" [(ngModel)]="planItem.featureId">
                                        <option *ngFor="let feature of featureList" [ngValue]="feature.id">
                                            {{feature.name}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-lg-2 col-md-2">
                                    <button class="btn btn-info btn-sm" type="button"
                                        (click)="AddRemoveFeature('plus')"> +
                                        feature</button>
                                </div>
                                <div class="card-content">
                                    <div class="col-lg-10 col-md-10">
                                        <div
                                            *ngFor="let ngo of planItem.features;let i = index;trackBy: trackFeatureById">
                                            <div class="col-lg-12" style="border: 1px gray dashed;">
                                                {{i}}: {{planItem.features[i].name}} ({{planItem.features[i].id}})
                                            </div>
                                            <br>
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-md-2">
                                        <button *ngIf="planItem.features != null && planItem.features.length > 0"
                                            class="btn btn-info btn-sm btn-danger" type="button"
                                            (click)="AddRemoveFeature('less')"> - feature</button>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <hr>
                                </div>
                            </div>
                        </div>
                        <div class="nome-descricao">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label class="control-label">Nome:</label>
                                        <input class="form-control" type="text" placeholder="Nome" name="name"
                                            [(ngModel)]="planItem.name" #name="ngModel" class="form-control" />
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Descrição:</label>
                                        <textarea type="text" class="form-control" [(ngModel)]="planItem.description"
                                            name="description" id="description"
                                            placeholder="Descrição">{{ planItem.description }}</textarea>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label class="control-label">Período:</label>
                                        <select class="form-control" (change)="populateDates()" name="period"
                                            [(ngModel)]="planItem.period">
                                            <option [value]="1">Mensal</option>
                                            <option [value]="3">Trimestral</option>
                                            <option [value]="6">Semestral</option>
                                            <option [value]="12">Anual</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">MRR:</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">R$</span>
                                            <input class="form-control" type="text" name="mrr" allowNegative="true"
                                                currencyMask [(ngModel)]="planItem.mrr"
                                                [options]="{ prefix: '', thousands: '.', decimal: ',' }" #mrr="ngModel"
                                                placeholder="0,00" style="text-align: left !important;" required />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <div>
                                            <label>Como o Polen é remunerado:</label>
                                            <select class="form-control" name="monetizationType"
                                                [(ngModel)]="planItem.monetizationType">
                                                <option [value]="0">Valor Fixo</option>
                                                <option [value]="1">Valor Percentual</option>
                                                <option [value]="100">Ambos</option>
                                            </select>
                                            <small *ngIf="planItem.monetizationType == 100">
                                                quando é ambos, ele pode ter um fixo + um percentual + um usage por
                                                exemplo
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <div>
                                            <label>Valor </label>
                                            <label
                                                *ngIf="planItem.monetizationType == 0 || planItem.monetizationType == 100">&nbsp;Fixo</label>
                                            <div>
                                                <div class="input-group"
                                                    *ngIf="planItem.monetizationType == 0 || planItem.monetizationType == 100">
                                                    <span class="input-group-addon">R$</span>
                                                    <input class="form-control" type="text" name="price" currencyMask
                                                        [(ngModel)]="planItem.price" allowNegative="true"
                                                        [options]="{ prefix: '', thousands: '.', decimal: ',' }"
                                                        #price="ngModel" placeholder="0,00"
                                                        style="text-align: left !important;" required />
                                                </div>
                                                <label
                                                    *ngIf="planItem.monetizationType == 1 || planItem.monetizationType == 100">&nbsp;Percentual</label>
                                                <div class="input-group"
                                                    *ngIf="planItem.monetizationType == 1 || planItem.monetizationType == 100">
                                                    <input class="form-control" type="text" name="percentage"
                                                        currencyMask [(ngModel)]="planItem.percentage"
                                                        [options]="{ prefix: '', thousands: '.', decimal: ',' }"
                                                        #percentage="ngModel" placeholder="0"
                                                        style="text-align: left !important;" required />
                                                    <span class="input-group-addon">%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="datacriacao">
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label class="control-label">De:</label>
                                        <input class="form-control" type="text" placeholder="mm/dd/yyyy"
                                            name="startDate" [(ngModel)]="planItem.startDate" #date="ngModel"
                                            class="form-control" />
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label class="control-label">Até:</label>
                                        <!-- <input class="form-control" type="text" placeholder="Data" name="endDate"
                                            mask='99/99/9999' [(ngModel)]="planItem.endDate" #date="ngModel"
                                            class="form-control" /> -->
                                        <input class="form-control" type="text" placeholder="mm/dd/yyyy" name="endDate"
                                            [(ngModel)]="planItem.endDate" #date="ngModel" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label class="control-label">Infinito:</label>
                                        <br>
                                        <label class="switch">
                                            <input type="checkbox" name="infinite" [checked]="planItem.infinite"
                                                (change)="planItem.infinite = !planItem.infinite">
                                            <span class="slider round"></span>
                                        </label>
                                        <br>
                                        <small>Item não tem uma data para acabar.</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="valores-boleanos">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label class="control-label">Ativo:</label>
                                        <label class="switch">
                                            <input type="checkbox" name="active" [checked]="planItem.active"
                                                (change)="planItem.active = !planItem.active">
                                            <span class="slider round"></span>
                                        </label>
                                        <br>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-right">
                            <button class="btn btn-info btn-fill" type="button" (click)="save()">Salvar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ngx-smart-modal>
<ngx-smart-modal #planItemBankFeeModal identifier="planItemBankFeeModal" customClass="medium-modal">
    <div *ngIf="planItem && planItem.bankFee">
        <h3>Taxas Bancárias deste Widget</h3>
        <p>Caso deixe vazio estes valores, é utilizado as taxas padrão do Polen. Caso contrário, preencha todas!</p>
        <div class="col-lg-6 col-md-6">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Cartão de Crédito</h4>
                </div>
                <div class="card-content">
                    <div class="row">
                        <div class="col-md-6 col-xs-6">
                            <div class="form-group">
                                <label> Taxa à vista</label>
                                <br><small>Percentual cobrado em pagamento à vista</small>
                                <!-- <input class="form-control" type="text" name="polenMRR" currencyMask [(ngModel)]="invoice.polenMRR"
                                      [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" #polenMRR="ngModel" placeholder="R$0,00"
                                      style="text-align: left !important;" required /> -->
                                <input class="form-control" type="text" name="userBankFee.creditCardPercentage"
                                    currencyMask [options]="{ prefix: '',suffix : '%', thousands: '.', decimal: ',' }"
                                    placeholder="0,00%" [(ngModel)]="planItem.bankFee.creditCardPercentage" required
                                    #creditCardPercentage="ngModel">
                            </div>
                        </div>
                        <div class="col-md-6 col-xs-6">
                            <div class="form-group">
                                <label> Taxa Anti Fraude</label>
                                <br><small>Valor em reais cobrado em cada pagamento</small>
                                <input class="form-control" type="text" name="creditCardAntiFraud" currencyMask
                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" placeholder="R$0,00"
                                    [(ngModel)]="planItem.bankFee.creditCardAntiFraud" maxlength="85"
                                    #creditCardAntiFraud="ngModel">
                            </div>
                        </div>
                        <div class="col-md-6 col-xs-6">
                            <div class="form-group">
                                <label> Taxa Parcelado</label>
                                <br><small>Percentual cobrado em pagamento parcelado</small>
                                <input class="form-control" type="text" name="creditCardInstallmentPercentage"
                                    currencyMask [options]="{ prefix: '',suffix : '%', thousands: '.', decimal: ',' }"
                                    placeholder="0,00%" [(ngModel)]="planItem.bankFee.creditCardInstallmentPercentage"
                                    maxlength="85" #creditCardInstallmentPercentage="ngModel">
                            </div>
                        </div>
                        <div class="col-md-6 col-xs-6">
                            <div class="form-group">
                                <label> Taxa Anti Fraude</label>
                                <br><small>Valor em reais cobrado em cada pagamento</small>
                                <input class="form-control" type="text" name="creditCardInstallmentAntiFraud"
                                    currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                                    placeholder="R$0,00" [(ngModel)]="planItem.bankFee.creditCardInstallmentAntiFraud"
                                    maxlength="85" #creditCardInstallmentAntiFraud="ngModel">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Boleto</h4>
                </div>
                <div class="card-content">
                    <div class="row">
                        <div class="col-md-6 col-xs-6">
                            <div class="form-group">
                                <label> Taxa por boleto</label>
                                <br><small>Valor fixo pago por boleto pago</small>
                                <input class="form-control" type="text" name="userBankFee.bankSlipFee" currencyMask
                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" placeholder="R$0,00"
                                    [(ngModel)]="planItem.bankFee.bankSlipFee" required #bankSlipFee="ngModel">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">PIX</h4>
                </div>
                <div class="card-content">
                    <div class="row">
                        <div class="col-md-6 col-xs-6">
                            <div class="form-group">
                                <label> Taxa por PIX</label>
                                <br><small>Valor fixo pago por PIX realizado</small>
                                <input class="form-control" type="text" name="userBankFee.pixFee" currencyMask
                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" placeholder="R$0,00"
                                    [(ngModel)]="planItem.bankFee.pixFee" required #pixFee="ngModel">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-right">
            <button type="button" (click)="savePlanItemBankFee(planItem)" class="btn btn-info btn-fill">Atualizar
                taxas</button>
        </div>
    </div>
</ngx-smart-modal>